import React from 'react';
import { useTheme } from '../contexts/ThemeContext';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiMoon, FiSun } = FiIcons;

const ThemeToggle = ({ className = "" }) => {
  const { theme, toggleTheme } = useTheme();

  return (
    <button
      onClick={toggleTheme}
      className={`flex items-center gap-3 w-full px-3 py-2.5 text-sm font-medium rounded-xl transition-all ${
        theme === 'dark'
          ? 'text-yellow-400 bg-yellow-400/10 hover:bg-yellow-400/20'
          : 'text-gray-600 bg-gray-50 hover:bg-gray-100 hover:text-gray-900'
      } ${className}`}
      title={theme === 'dark' ? 'Bytt til dagmodus' : 'Bytt til nattmodus'}
    >
      <div className="flex items-center justify-center w-5 h-5">
        <SafeIcon icon={theme === 'dark' ? FiSun : FiMoon} className="text-lg" />
      </div>
      <span>{theme === 'dark' ? 'Dagmodus' : 'Nattmodus'}</span>
    </button>
  );
};

export default ThemeToggle;